import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { addPackageToUniteReq } from '../packageReqService'

export const useAddPackageToUnite = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: addPackageToUniteReq,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PACKAGE_REQUESTS] })
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_PACKAGES] })
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.BACKOFFICE_USER_PACKAGES] })
    },
  })
}
